<template>
    <div class="detail-remark">
        <div class="touch-strip" v-if="baseData.remarkCount > 0" @click="opencComment">
            <div class="content">
                <h2>顾客<span>点评({{baseData.remarkCount}})</span></h2>
                <span class="more" v-if="baseData.remarkSatisfaction">{{baseData.remarkSatisfaction}}%满意度</span>
            </div>
            <i class="arrow"></i>
        </div>
        <div class="one-remark" v-if="baseData.oneRemark">
            <div class="one-remark-title">
                <img :src="baseData.oneRemark.userImage || 'http://img3.tuniucdn.com/img/20140811/usercenter_lxl/default.gif'" class="avatar">
                <span class="user-name" v-if="baseData.oneRemark.userName">{{baseData.oneRemark.userName}}</span>
                <span class="remark-date" v-if="baseData.oneRemark.remarkDate">{{baseData.oneRemark.remarkDate}}</span>
            </div>
            <div class="one-remark-cont" v-if="baseData.oneRemark.remarkContent">
                {{baseData.oneRemark.remarkContent}}
            </div>
            <div class="one-remark-imgs">
                <ul v-if="baseData.oneRemark.images && baseData.oneRemark.images.length">
                    <li v-for="(item, index) of baseData.oneRemark.images" :key="index" v-if="index < 4"><img v-lazy="replaceProtocol(item.thumbUrl)"></li>
                </ul>
            </div>
        </div>
        <div class="no-remark-tip"  v-if="!baseData.remarkCount || baseData.remarkCount === 0">
            <h2>顾客<span>点评</span></h2>暂无点评
        </div>
    </div>
</template>

<script>
import {eventTrack} from '@/business/analy';

export default {
    name: 'remark',
    props: {
        baseData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    created: function () {
    },
    methods: {
        opencComment() {
            this.$router.push(this.$route.path + '/comment');
            eventTrack('CLICK_INDEX_COMMENT');
        },
        replaceProtocol(url) {
            return url ? url.replace(/^http:/g, 'https:') : "";
        }
    }
}
</script>

<style lang="scss">
@import '../style/common.scss';

.detail-remark {
    position: relative;
    margin: 9px 0;
    overflow: hidden;
    border-radius: $borderBigRadius;
    background: #fff;
    .touch-strip {
        display: block;
        padding: 13px 33px 13px 0;
        line-height: 24px;
        height: 24px;
        h2 {
            position: absolute;
            font-size: 18px;
            font-weight: 700;
            color: $fontStrongColor;
            span {
                font-weight: 300;
            }
        }
    }
    .one-remark {
        padding: 2px 18px 10px;
        color: $fontStrongColor;
        font-weight: 300;
        .one-remark-title {
            height: 30px;
            font-size: 13px;
            line-height: 30px;
            img {
                float: left;
                background:#fff;
                width:30px;
                height:30px;
                border-radius:100%;
            }
            .user-name {
                float: left;
                margin-left: 8px;
                
            }
            .remark-date {
                float: right;
            }
        }
        .one-remark-cont {
            font-size:15px;
            line-height:21px;
            margin-top: 12px;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }
        .one-remark-imgs {
            position: relative;
            padding-top: 25%; 
            margin: 12px 0 4px;
            &:empty {
                padding-top: 0; 
                margin: 0;
            }
            ul {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-between;
                @supports (display: grid) {
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr 1fr;
                    grid-column-gap: 2px;
                }
            }
            li {
                position: relative;
                overflow: hidden;
                flex: 1;
                margin: 0 1px;
                @supports (display: grid) {
                    margin: 0;
                }
                &:first-child {
                    border-top-left-radius: $borderMiddleRadius;
                    border-bottom-left-radius: $borderMiddleRadius;
                    margin-left: 0;
                    @supports (display: grid) {
                        margin: 0;
                    }
                }
                &:last-child {
                    border-top-right-radius: $borderMiddleRadius;
                    border-bottom-right-radius: $borderMiddleRadius;
                    @supports (display: grid) {
                        margin: 0;
                    }
                }
                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
                img[src=""], img:not([src]){
                    opacity:0;
                }
            }
        }
    }
    .no-remark-tip {
        font-weight: 300;
        font-size: 14px;
        color: $fontStrongColor;
        height: 18px;
        line-height: 18px;
        padding: 16px 18px;
        text-align: right;
        h2 {
            float: left;
            font-size: 18px;
            font-weight: 700;
            span {
                font-weight: 300;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Remark.vue